import getBasePath from '@/common/functions/api-resource';
import resourceBuilder from '../functions/metadados-resource-builder';

const basePath = getBasePath('workflow', 'execucao/apuracao-acao');

const workflowApuracaoAcaoActions = {
  aprovacaoMassiva: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/{idTipoUso}/{idAcao}/{justificativaTipoUso}/aprovacao-massiva{?dataContabilizacao*}` },
  aprovador: { method: 'GET', url: `${basePath}/{idApuracao}/passos/aprovador` },
  aprovarPasso: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/aprovar` },
  associaUsuarioFornecedorAprovador: { method: 'POST', url: `${basePath}/{idApuracao}/passos/{idPasso}/fornecedor/usuario/{idUsuario}` },
  buscaPassosFornecedor: { method: 'GET', url: `${basePath}/{idApuracao}/passos/fornecedor` },
  cancelar: { method: 'PUT', url: `${basePath}/{idApuracao}/cancelar` },
  enviarAnalise: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/analise` },
  enviarAnaliseApuracaoPorInativacaoFornecedor: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/{observacao}/analise-apuracao-por-inativacao-fornecedor` },
  enviarAnaliseDadosMassivos: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/{observacao}/{idTipoUso}/{idAcao}/{justificativaTipoUso}/analise-dados-massivos` },
  existeFluxoCadastrado: { method: 'GET', url: `${basePath}/{idApuracao}/fluxo-cadastrado` },
  iniciaFluxo: { method: 'POST', url: `${basePath}/{idApuracao}` },
  reprovacaoMassiva: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/{observacao}/{idTipoUso}/{idAcao}/{justificativaTipoUso}/reprovacao-massiva` },
  reprovar: { method: 'PUT', url: `${basePath}/{idApuracao}/passos/reprovar` },
  salvarApuracaoAcaoContratoTipoUso: { method: 'PUT', url: `${basePath}/fluxo/salvar-apuracao-acao-contrato-tipo-uso/{idApuracao}` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante/{idApuracao}` },
  statusPasso: { method: 'GET', url: `${basePath}/{idApuracao}/passos/status` },
};
export default (resource) => resource(`${basePath}`, {}, workflowApuracaoAcaoActions);

export const pendencias = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'pendencias', parametros).doGet();
